"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkToRecordEditor;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function LinkToRecordEditor(_ref) {
  var column = _ref.column,
      onClose = _ref.onClose,
      row = _ref.row;
  var key = column.key,
      onClickAdd = column.onClickAdd;
  var value = row[key] || [];
  (0, _react.useEffect)(function () {
    document.getElementById("link-editor").click();
  }, []);

  var handleClick = function handleClick(e) {
    if (typeof onClickAdd === "function") {
      onClickAdd({
        value: value,
        row: row,
        column: column,
        currentTarget: e.currentTarget,
        variant: "expand"
      });
      onClose(true);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "link-editor",
    onClick: handleClick
  });
}

LinkToRecordEditor.propTypes = {
  row: _propTypes["default"].object,
  column: _propTypes["default"].object,
  onRowChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};